<script lang="ts">
  import { run } from "svelte/legacy";

  import RangeSlider from "svelte-range-slider-pips";
  import Card from "../atoms/Card.svelte";
  import Heading from "../atoms/Heading.svelte";
  import NumberInput from "../atoms/NumberInput.svelte";
  import Text from "../atoms/Text.svelte";
  import EstimationIcons from "../atoms/EstimationIcons.svelte";
  import { type ResidenceTypes } from "../../helpers/types";

  interface Props {
    inputEstimationValue: number;
    residenceType: ResidenceTypes | undefined;
    heading?: import("svelte").Snippet;
    text?: import("svelte").Snippet;
  }

  let { inputEstimationValue = $bindable(), residenceType, heading, text }: Props = $props();
  let values = $state([inputEstimationValue]);

  const getLabel = (e: number) => {
    let label = "";
    let range = "";
    if (e <= 9000) {
      label = "Lägenhet";
      if (e <= 1500) {
        range = "20 - 49";
      } else if (e <= 5000) {
        range = "50 - 79";
      } else {
        range = "80 - 130";
      }
    } else if (e <= 26000) {
      label = "Hus";
      if (e <= 13000) {
        range = "50-79";
      } else if (e <= 19000) {
        range = "80 - 119";
      } else {
        range = "120 - 170";
      }
    } else {
      label = "Stor villa";
      range = "170-250";
    }

    return `${label} ${range} kvm`;
  };

  $effect(() => {
    if (inputEstimationValue > 35000) {
      inputEstimationValue = 35000;
    } else if (inputEstimationValue < 0) {
      inputEstimationValue = 1;
    }
  });
</script>

<Card>
  <Heading>{@render heading?.()}</Heading>
  <Text>{@render text?.()}</Text>
  <div class="flex flex-col-reverse md:flex-row-reverse mt-10">
    <div class="mt-6 md:mt-0 self-start items-center">
      <NumberInput
        onInput={(e) => (values[0] = e.target.value)}
        class="w-20"
        name="estimation"
        id="estimation"
        bind:value={inputEstimationValue}
        max={35000}
      />
      <label for="estimation" class="text-Neutral900 text-M ml-2">kWh/år</label>
    </div>
    <div class="w-full mt-3">
      <RangeSlider
        on:change={(e: any) => (inputEstimationValue = e.detail.value)}
        id="slider"
        min={0}
        step={100}
        formatter={(v: number) => getLabel(v)}
        max={35000}
        bind:values
      />
      {#if residenceType}
        <EstimationIcons {residenceType} />
      {/if}
    </div>
  </div>
</Card>
